import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import i18next from 'i18next';
import Immutable from 'immutable';
import { CoreLink } from '@uncinc/react-drupal-core';

import {
  WysiwygField,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import { formatMoneyFromString } from '../../../../helpers';

import { Badge } from '../../../../components';

import './style.scss';

const CourseInfoTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'CourseInfoTeaser');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const link = entity.getIn(['field_sign_up_link', 0, 'uri'], '-');
  const courses = entity.get('field_courses', Immutable.List());
  const sortedCourses = courses.sort((a, b) => {
    const aDate = new Date(a.getIn(['entity', 'field_date_range', 0, 'value']));
    const bDate = new Date(b.getIn(['entity', 'field_date_range', 0, 'value']));
    return aDate - bDate;
  });
  const theme = entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '');
  const courseType = entity.getIn(['field_training_type', 0, 'entity', 'name', 0, 'value'], '');
  const sortedCoursesHighCost = courses.sort((a, b) => {
    const aCost = new Date(a.getIn(['entity', 'field_cost', 0, 'value'], 0));
    const bCost = new Date(b.getIn(['entity', 'field_cost', 0, 'value'], 0));
    return aCost > bCost;
  });
  const cost = sortedCoursesHighCost.get(0).getIn(['entity', 'field_cost', 0, 'value'], 0);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={entity.getIn(['paths', 'nl'], '')} className="overlapping-link" />
      <div className="CourseInfoTeaser__content">
        <div className="CourseInfoTeaser__contentWrapper">
          <div>
            {theme && (
              <Badge theme={theme} type={courseType} />
            )}

            <div>
              <h3 className="CourseInfoTeaser__title">
                {title}
              </h3>
            </div>

            {entity.getIn(['body', 0, 'processed']) ? (
              <div className="CourseInfoTeaser__contentWrapper__body">
                <WysiwygField
                  property="schema:text"
                  className="node--page--body"
                  html={body}
                />
              </div>

            ) : null}
          </div>

          <div className="CourseInfoTeaser__info">
            <div className="CourseInfoTeaser__info__item">
              <div className="CourseInfoTeaser__info__title">
                {i18next.t(sortedCourses.size > 1 ? 'upcoming_dates' : 'date')}
              </div>
              <div className="CourseInfoTeaser__info__body">
                {sortedCourses.slice(0, 3).map((course, index) => {
                  const date = moment(course.getIn(['entity', 'field_date_range', 0, 'value']));
                  const locationName = course.getIn(['entity', 'field_location', 0, 'value'], '');

                  return (
                    <div className="CourseTeaser__info__body" key={`course-date-${index}`}>
                      {date.format('DD-MM-YYYY')}, {locationName}
                    </div>
                  );
                })}
                {sortedCourses.size > 3 && (
                  <CoreLink to={link}>
                    {i18next.t('more_dates')}
                  </CoreLink>
                )}
              </div>
            </div>
            <div className="CourseInfoTeaser__info__item">
              <div className="CourseInfoTeaser__info__title">{i18next.t('costs')}</div>
              <div className="CourseInfoTeaser__info__body">{cost !== 0 ? formatMoneyFromString(cost) : '-'}</div>
            </div>
            <Button
              className="Button--primary action"
              href={link}>
              {i18next.t('more_info')}
            </Button>
          </div>

        </div>
      </div>
    </article>
  );
};

export default CourseInfoTeaser;
